module.exports = __webpack_public_path__ + "static/media/notification.d529f4f7.png";